import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'antd';
import { SwapOutlined } from '@ant-design/icons';
import { setPmState } from '../../../store/entities/pm';

const PhaseButton = (props) => {
  const dispatch = useDispatch();
  const index = props.index;
  const phases = useSelector(state => state.entities.pm.phases);
  const marginLeft = (props.marginLeft) ? props.marginLeft : '0px';

  const handleClick = () => {
    const newPhases = { ...phases };
    if (index < 8) {
      newPhases[index] = phases[index + 1];
      newPhases[index + 1] = phases[index];
    } else {
      newPhases[index - 7] = phases[index - 3];
      newPhases[index - 3] = phases[index - 7];
    }
    dispatch(setPmState({
      phases: newPhases,
    }));
  };

  return (
    <Button style={{
      width: '40px',
      marginLeft: marginLeft,
      display: 'none'
    }} onClick={handleClick}>
      <SwapOutlined/>
    </Button>
  );
};
export default PhaseButton;

